<div
  class="container"
  [ngClass]="{ 'show-padding': focus !== 'thread' && screenWidth < 767 }"
>
  <div
    class="inner-container"
    [ngClass]="{
      'theme-background-color': screenWidth < 767,
      'large-element-rounding-mobile-view':
        focus !== 'thread' && screenWidth < 767
    }"
  >
    <app-task-detail
      [orgId]="orgId"
      [taskId]="taskId"
      [focus]="focus"
      [context]="'inbox'"
    >
    </app-task-detail>
  </div>
</div>
